import React from 'react';
import ButtonBlue from '../../Buttons/ButtonBlue';
import './headline.css'; 

const HeadlineSection = () => {
    return (
        <div 
        className="headline-section gradient-light-blue"
        >
            <h1 className="title-blue">Welcome to My World: Technology, Health, and Personal Growth</h1>
            <p className="headline-intro">
                Hi, I’m Claudiu Dobre. With over 20 years of experience in various fields—from full-stack web development to health coaching and instrumentation—I’m passionate about merging technology with health and wellness. Explore my journey from overcoming personal health challenges to empowering others through digital solutions, holistic health practices, and inspiring personal growth. Let’s connect, create, and thrive together.
            </p>
            <div className="headline-buttons">
                <ButtonBlue destination={'/projects'} text={'View My Projects'} />
                <ButtonBlue destination={'/blog'} text={'Read My Blogs'} />
                <ButtonBlue destination={'/photography'} text={'View My Photography'} />
            </div>
        </div>
    );
};

export default HeadlineSection;